<form [formGroup]="editUserForm" (ngSubmit) = "onSubmit()">
<p-dialog  [(visible)]="displayDialog" 
  [modal]="true" 
  [positionTop]="50" 
  [maximizable]="true"
  [contentStyle]="{'min-width':'640px'}"
  (onHide)="dialogClose()">
  <p-header>
    <b>Edit User</b>
  </p-header>
    <div class="ui-grid ui-grid-responsive formcontainer"> 
      <div formGroupName="PersonDetail">
        <div class="formgroup">
          <div class="ui-grid-row">
            <div class="ui-grid-col-12">
              <label for="Email">Email Address</label>
            </div>
          </div>
          <div class="ui-grid-row">
            <div class="ui-grid-col-6">
              {{userRelationship.PersonDetail.Email}}
            </div>
            <div class="ui-grid-col-6" *ngIf="showResetPasswordSection(userRelationship)">
              <div class="align-right" *ngIf="showResetPasswordLink">
                <a (click)="showResetCancelButtons()" class="cursor align-right">Reset Password</a>
              </div>  
              <div *ngIf="enableResetCancelButtons" class="align-right">
                <button type="button" class="green-button" (click)="emailResetPasswordLink()">Confirm Reset</button>
                <button type="button" class="red-button" (click)="hideResetCancelButtons()">Cancel</button>
              </div>
              <div *ngIf="emailStatus">
                <span class="check-circle-green">
                  <i class="pi pi-check-circle pi-circle-font"></i>
                  <span style="font-size: 0.6em">Password Reset and link email sent</span>
                </span>
              </div>
              <i class="pi pi-spin pi-spinner spinner-font" *ngIf="loading"></i>
            </div>
            <div class="ui-grid-col-6" *ngIf="userRelationship.PersonDetail.IsPreReg">
                <button pButton type="button" label="Reset/Resend Initial Email" class="ui-button-secondary" (click)="resendEmail()"></button>
            </div>
          </div>   
        </div>
        <div class="formgroup">
          <div class="ui-grid-row">
            <div class="ui-grid-col-12">
              <label for="Name">Name:</label>    
            </div>
          </div>
          <div class="ui-grid-row">
            <div class="ui-grid-col-12">
              {{userRelationship.PersonDetail.FirstName}} {{userRelationship.PersonDetail.LastName}}
            </div>
          </div>
        </div>
        <div class="formgroup">
          <div class="ui-grid-row">
            <div class="ui-grid-col-12">
              <label for="Phone">Phone:</label>    
            </div>
          </div>
          <div class="ui-grid-row">
            <div class="ui-grid-col-12">
              {{userRelationship.PersonDetail.Phone | phone}}
            </div>
          </div>
        </div>
        <div class="formgroup">
          <div class="ui-grid-row">
            <div class="ui-grid-col-12">
                <label for="loginEnabled">User Login :</label> {{loginStatus.value ? 'Enabled' : 'Disabled' }}
            </div>
          </div>
          <div class="ui-grid-row" *ngIf="displayLoginstatus">
            <div class="ui-grid-col-12">
                <p-inputSwitch formControlName="loginEnabled"></p-inputSwitch>
            </div>
          </div>
        </div>
        <div class="formgroup">
          <div class="ui-grid-row">
            <div class="ui-grid-col-12">
                <label for="loginEnabled">User Status: </label> {{personStatus.value ? 'Active' : 'Inactive'}}
            </div>
          </div>
          <div class="ui-grid-row">
            <div class="ui-grid-col-12">
                <p-inputSwitch formControlName="IsActive" (onChange)="changePrimaryContact($event)"></p-inputSwitch>
            </div>
          </div>
        </div>
        <div class="formgroup" *ngIf="displayNewContactList && isPrimaryContact">
          <app-change-primary-contact 
            [PersonId]="userRelationship.PersonDetail.PersonId"
            (RelationshipAndContactId)="mapRelationshipAndContactId($event)"
            (IsPrimaryContactReady)="checkIsPrimaryContactReady($event)">
          </app-change-primary-contact>
        </div>
      </div>
    </div>
  <p-footer>
      <button pButton type="button" label="Cancel" class="ui-button-secondary" (click)="dialogClose()"></button>
      <button pButton type="submit" label="{{processing ? 'Processing' : 'Update User'}}" 
        [disabled]="processing || editUserForm.invalid || !isPrimaryContactSelected"></button>
  </p-footer>
</p-dialog>
</form>
<p-overlayPanel #op1 [dismissable]="true">
  <ul>
    <li *ngFor="let item of displayItems">{{item}}</li>
  </ul>
</p-overlayPanel>
<p-overlayPanel #op2 [dismissable]="true">
  <div *ngFor="let rel of displayItems">
    <ul>
      <li>
        <b>{{rel.RelationshipName}}</b>
        <ul>
          <li *ngFor="let group of assetGroupByRelationhipId(rel.Id)">{{group.RelationshipGroupName}}</li>
        </ul>
      </li>
    </ul>
  </div>
</p-overlayPanel>
<p-confirmDialog header="User Status" icon="pi pi-exclamation-triangle"></p-confirmDialog>